// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import AppLogPagingResultModel from '../../model/app-log-paging-result-model';
import AppLogPagingResultDTO from '../dto/app-log-paging-result-dto';
import dtoSchema from '../schemas/app-log-paging-result-schema';
import AppLogModel from '../../model/app-log-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class AppLogPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<AppLogPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => AppLogModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: AppLogModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<AppLogPagingResultDTO>): AppLogPagingResultModel;
  static toModel(dto: DeepPartial<AppLogPagingResultDTO> | undefined | null): AppLogPagingResultModel | undefined;
  static toModel(dto: DeepPartial<AppLogPagingResultDTO> | undefined | null): AppLogPagingResultModel | undefined {
    return dto ? new AppLogPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<AppLogPagingResultModel> | AppLogPagingResultModel): AppLogPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as AppLogPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for AppLogPagingResultModel, can not map to AppLogPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
